import { ChangeDetectorRef, Component, ComponentRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import OverlayScrollbars from 'overlayscrollbars';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-ngx';
import { NavigationService } from 'src/app/navigation/navigation.service';
import { ModuleInfo } from 'src/shared/models/module-info.model';
import { ModuleGroup } from 'src/shared/services/navigation-service-base';
import { DashboardService } from '../dashboard.service';

@Component({
    selector: 'cv-sidebar-module-list',
    templateUrl: './sidebar-module-list.component.html',
    styleUrls: ['./sidebar-module-list.component.scss']
})
export class SidebarModuleListComponent implements OnInit, OnChanges {
    @Input() modules: ModuleInfo[];
    @Input() grouped = false;
    @Input() filterText = '';

    @Output() openPreview = new EventEmitter<void>();
    @Output() closePreview = new EventEmitter<void>();
    @Output() previewModuleChange = new EventEmitter<ModuleInfo>();

    scrollOptions: OverlayScrollbars.PartialOptions = {
        scrollbars: {
            autoHide: "leave",
            autoHideDelay: 100,
            theme: "os-theme-light",
        },
    };

    expandedGroups = new Set<string>();
    filteredGroups: ModuleGroup[] = [];
    private groups: ModuleGroup[] = [];

    constructor(
        public navigationService: NavigationService,
        public dashboardService: DashboardService,
    ) {
        this.navigationService.groupedModules.subscribe(groups => {
            this.groups = groups;
            this.filterModuleGroups();
        });
    }

    ngOnInit(): void {

    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.filterText) {
            this.filterModuleGroups();
        }
    }

    filterModuleGroups() {
        this.filteredGroups = this.groups.filter(group => {
            if (!this.filterText)
                return true;
            const searchString = this.filterText.toLowerCase();
            return group.modules.some(module => module.LocalizedName.toLowerCase().includes(searchString));
        });
    }

    getModuleGroupSvgPath(iconName) {
        if (!iconName)
            return null;

        return `${window['_BaseURI']}/App_Themes/clearview-default/icons/utility/${iconName}.svg#${iconName}`;
    }

    onModuleGroupClicked(moduleGroup: ModuleGroup) {
        if (!this.expandedGroups.delete(moduleGroup.localizedGroup)) {
            this.expandedGroups.add(moduleGroup.localizedGroup);
        }
        this.closePreview.emit();
    }

    onModuleClicked(module: ModuleInfo) {
        if (this.navigationService.addingModule || this.navigationService.showOverlay)
            return;

        // pre-emptively show overlay
        if (module.options.settingsAvailable)
            this.navigationService.showOverlay = true;

        this.navigationService.addingModule = true;
        this.closePreview.emit();
        this.dashboardService.addModuleEvent.next(module);
    }

    onDragStart(event: DragEvent, module: ModuleInfo) {
        this.closePreview.emit();
        this.dashboardService.draggingModule = module;
    }

    onDragEnd(event: DragEvent, module: ModuleInfo) {
        this.dashboardService.draggingModule = null;
    }
}
